export function getSafariVersion(): string {
    const browserVersion = (userAgent, regex) => {
        return userAgent.match(regex) ? userAgent.match(regex)[2] : null;
    };
    const userAgent = navigator.userAgent;
    let browser = 'unkown';
    // Detect browser name
    browser =
        /safari/i.test(userAgent) &&
        !/chromium|edg|ucbrowser|chrome|crios|opr|opera|fxios|firefox/i.test(
            userAgent
        )
            ? 'Safari'
            : browser;
    // detect browser version
    switch (browser) {
        case 'Safari':
            return `${browser}/${browserVersion(
                userAgent,
                /(version)\/([\d.]+)/i
            )}`.split('/')[1];
        default:
            return null;
    }
}

/**
 * Detects if the current device is running iOS
 * @returns {boolean} True if the device is running iOS
 */
export const isIOS = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    return (
        /iphone|ipad|ipod/.test(userAgent) ||
        // Detect iPad on iOS 13+ (which reports as Macintosh)
        (userAgent.includes('macintosh') && 'ontouchend' in document)
    );
};

/**
 * Detects if the current device is running macOS
 * @returns {boolean} True if the device is running macOS
 */
export const isMacOS = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.includes('macintosh') && !isIOS();
};

export function findScrollAncestor(element: HTMLElement): HTMLElement {
    for (
        let parent = element.parentElement;
        parent;
        parent = parent.parentElement
    ) {
        const { overflow } = window.getComputedStyle(parent);
        if (overflow.split(' ').every(o => o !== 'clip' && o !== 'visible')) {
            return parent;
        }
    }

    return document.documentElement;
}

/**
 * Safely retrieves the document body in both browser and SSR environments.
 * Prevents "global is not defined" errors in browsers while supporting
 * SSR environments that might inject document into the global scope.
 */
export const getDocumentBody = (): HTMLElement | null => {
    if (typeof document !== 'undefined') {
        return document.body;
    }
    // eslint-disable-next-line no-undef, no-restricted-globals -- deliberate typeof-guarded SSR env detection
    if (typeof global !== 'undefined') {
        // eslint-disable-next-line no-undef, no-restricted-globals -- deliberate typeof-guarded SSR env detection
        return (global as any).document?.body ?? null;
    }
    return null;
};
